import { Hue, HueVariant } from "ipctg-inflow-types/InFlowThemes"
import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from "react"

import { cn } from "@/utilities/etc"

import styles from "./Card.module.css"

interface Props
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  hue?: Hue
  variant?: HueVariant
}

function Card(props: PropsWithChildren<Props>) {
  return (
    <div
      {...props}
      className={cn(props.className, styles.card)}
      data-hue={props.hue || "neutral"}
      data-variant={props.variant || "default"}
    >
      {props.children}
    </div>
  )
}

export default Card
